module.exports = __webpack_public_path__ + "img/case-logo-09.7f62bc3d.png";